import React from "react";
import "./Phonetic.css";

export default function Phonetic(props) {
  console.log(props.phonetic);
  return (
    <div className="Phonetic">
      <a
        className="phoneticsLink"
        href={props.phonetic.audio}
        target="_blank"
        rel="noreferrer"
      >
        Listen 🔉
      </a>
      <span>{props.phonetic.text} </span>
    </div>
  );
}
